import { FC } from 'react';

import BackButton from 'components/BackButton';
import { StepProps } from 'components/Stepper/types';
import * as Layout from 'layouts/StickyStepperLayout';

import { useRequestNewCardContext } from '../../hooks/useRequestNewCardContext';
import { SetupBudgetCardForm } from './components/SetupBudgetCardForm';

const SetupBudgetCard: FC<StepProps> = ({ goBack, goNext }) => {
  const { setSharedState } = useRequestNewCardContext();

  return (
    <Layout.Root>
      <Layout.Body>
        <Layout.HeaderButtonsContainer>
          <BackButton onClick={goBack} />
        </Layout.HeaderButtonsContainer>
        <SetupBudgetCardForm
          onSubmit={(values) => {
            setSharedState((prevState) => ({
              ...prevState,
              budgetCardAmount: values.amount,
              budgetCardDescription: values.description,
            }));

            goNext();
          }}
        />
      </Layout.Body>
    </Layout.Root>
  );
};

export default SetupBudgetCard;
